import React from 'react';

export interface TextAreaProps {
  id?: string;
  className?: string;
  placeholder?: string;
  value?: string;
  defaultValue?: string;
  disabled?: boolean;
  onChange?(text: string): void;
  onFocus?(e: React.FocusEvent<HTMLTextAreaElement, Element>): void;
  onBlur?(e: React.FocusEvent<HTMLTextAreaElement, Element>): void;
  onKeyDown?(e: React.KeyboardEvent<HTMLTextAreaElement>): void;
}

export const TextArea = (props: TextAreaProps) => {
  return (
    <textarea
      id={props.id}
      // Matches Input's contract. This previously set a border and a font but
      // no background or text colour, so with preflight off it fell through to
      // the UA default -- a white box with black text, which is unreadable on
      // the obsidian page. Same 13px / focus ring / disabled treatment as Input
      // so the two never drift.
      className={`box-border rounded-input border border-mid bg-page px-3 py-2 font-sans text-[13px] text-fg-1 placeholder:not-italic placeholder:text-fg-3 focus-visible:border-primary/50 focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:outline-none disabled:cursor-not-allowed disabled:bg-page-alt${props.className ? ` ${props.className}` : ''}`}
      placeholder={props.placeholder || ''}
      value={props.value}
      defaultValue={props.defaultValue}
      disabled={props.disabled}
      onChange={(e) => props.onChange?.(e.target.value)}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      onKeyDown={props.onKeyDown}
    />
  );
};
